import React, { useEffect, useState } from "react";
import { Menu, MenuItem, MenuButton, useAuthenticator, ButtonVariations, View, Flex, Button, Loader, Alert } from "@aws-amplify/ui-react";
import { useLocation, useNavigate } from "react-router-dom";
import { getTaskAPI } from "../../data/api";
import { format } from "date-fns";
import TaskMenu from "../Header/TaskMenu";
import TaskCard from "../../pages/task/TaskCard";

const TaskWindow = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const [task, setTask] = useState(undefined);
  const [showWindow, setShowWindow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getTask = async () => {
    const queryParams = new URLSearchParams(location.search);
    const taskId = queryParams.get('task');
    if(taskId !== null){
      setShowWindow(true)
      try{
        setLoading(true);
        setError(false);
        const task = await getTaskAPI(taskId);
        setTask(task);
        setLoading(false);
      } catch (e) {
        console.log('Loading task failed ', e);
        setError(true);
        setLoading(false);
      }
    } else {
      setShowWindow(false)
      setTask(undefined);
    }
  }

  useEffect(() => {
    getTask();
  }, [location.search])

  return (
    <>
      { !showWindow ? 
        <></> : 
        <View marginBottom="20px">
          {loading ? <Loader marginLeft="50%"/> : 
          error ? <Alert variation="error">Errore nel caricamento del task</Alert> : 
          <TaskCard task={task}/>}
        </View>
      }
    </>
  );
};

export default TaskWindow;
